// @flow
import * as React from 'react';

import ContainerWithAside from 'shared/components/ContainerWithAside';
import ApplicationSidebar from 'shared/partials/ApplicationSidebar';

import { captureException } from '../../utils/errorTracking/errorTracking';

import { ErrorPage } from '../ErrorPage';
import styles from './ErrorBoundary.module.css';
import { Heading } from 'operation-diameter';

type Props = {
  children: React.Node
};

type State = {
  hasError: boolean
};

export class AbstractErrorBoundary extends React.Component<Props, State> {
  state = { hasError: false };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    captureException(error, errorInfo);
  }
}

// If there is an error rendering the error page, just print a basic error
export class FallbackErrorBoundary extends AbstractErrorBoundary {
  render() {
    if (this.state.hasError) {
      return (
        <section className={styles.container}>
          <Heading headingSize='h3'>
            Sorry, that didn&apos;t work as expected
          </Heading>
        </section>
      );
    }

    return this.props.children;
  }
}

export class ErrorBoundary extends AbstractErrorBoundary {
  render() {
    if (this.state.hasError) {
      return (
        <FallbackErrorBoundary>
          <ContainerWithAside
            content={<ErrorPage />}
            asideContent={<ApplicationSidebar />}
            themeName='contrast'
          />
        </FallbackErrorBoundary>
      );
    }

    return this.props.children;
  }
}
